<template>
  <div class="dispute-with-voice">
    <div class="dispute-with-voice__header">
      <div>Dispute with voice</div>
      <Button
        label="Update voice (DwV)"
        class="dispute-with-voice__header__button"
        appearance="secondary"
        icon="plus"
        icon-position="left"
        :disabled="!getIsEditor || checkIfDisputeEditable()"
        @onClick="() => (openVoiceDispute = true)" />
    </div>
    <div class="details-tab-area">
      <tabs :items="dwvTabItems" />
    </div>
    <div v-if="activeTab === 'voice_history'" :class="tableParentClass">
      <Table
        :default-columns="defaultCol"
        :row-data="data"
        primary-key="ohpDisputeVoiceId"
        cell-background="#fff"
        header-cell-background="#f7f7f7"
        :header-position-top="0"
        :table-padding-bottom="36"
        :table-action-columns="tableActionColumns"
        has-select-checkbox
        :selected-rows="selectedRowByIds"
        @checkIsDisabled="checkIsDisabled"
        @selectChangeEvent="selectChangeEvent"
        @selectAllEvent="selectChangeEvent"
        @addParentClass="addParentClass">
        <template #default="{ row, col }">
          <span
            v-if="col.slotKey === 'voiceSummary'"
            v-html="getTableCellValue(row, col)"></span>
          <!-- <span v-else-if="col.slotKey === 'delete'">
            <icon class="theme--light pointer" name="trash" /> 
          </span> -->
          <span v-else-if="col.slotKey === 'more'">
            <more-dropdown
              :dropdown-items="voiceDisputeTableMoreOptions"
              :show-dropdown="
                activeVoiceDispute &&
                row.ohpDisputeVoiceId === activeVoiceDispute.ohpDisputeVoiceId
              "
              :on-click-data="row"
              @onClick="editVoiceDispute"
              @onMoreOptionClick="onMoreOptionClick" />
          </span>
          <span v-else>{{ getTableCellValue(row, col) }}</span>
        </template>
      </Table>
      <div v-if="selectedRowByIds.length" class="details-tab-area__action">
        <Button
          label="Hand Over to Collections"
          appearance="primary"
          @onClick="handOverDataToCollections" />
      </div>
    </div>
    <dispute-with-voice-modal
      v-if="openVoiceDispute"
      :case-details="caseDetails"
      :voice-dispute-data="activeVoiceDispute"
      :disputes-constants="disputesConstants"
      @onModalClose="onModalClose()"
      v-on="$listeners" />
    <voice-dispute-edit-history-modal
      v-if="openVoiceDisputeEditHistory"
      :edit-history="editHistory"
      @onModalClose="onModalClose()" />
  </div>
</template>

<script>
import { MoreDropdown } from "@/components/common";
import { voiceHistoryConfig, dwvTabItems } from "@/config/constant.js";
import DisputeWithVoiceModal from "@/components/DisputeUpdateModals/DisputeWithVoiceModal/DisputeWithVoiceModal.vue";
import VoiceDisputeEditHistoryModal from "@/components/DisputeUpdateModals/DisputeWithVoiceModal/VoiceDisputeEditHistoryModal.vue";

import {
  voiceDisputeTableMoreOptions,
  tableActionColumns,
} from "@/config/disputeUpdateModalConstant.js";

// Utils
import { format } from "date-fns";
import { getZonedTime } from "@/utils/helpers";
import { mapGetters } from "vuex";

export default {
  name: "DisputeWithVoice",
  components: {
    DisputeWithVoiceModal,
    VoiceDisputeEditHistoryModal,
    MoreDropdown,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true,
    },
    caseDetails: {
      type: Object,
      default: () => ({
        isDisputeEditable: true, // Default to true
      }),
      required: true,
    },
    disputesConstants: {
      type: Object,
      default: () => {},
    },
    editHistory: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultCol: voiceHistoryConfig,
      tableParentClass: "",
      openVoiceDispute: false,
      activeVoiceDispute: null,
      dwvTabItems,
      activeTab: "voice_history",
      openVoiceDisputeEditHistory: false,
      voiceDisputeTableMoreOptions,
      tableActionColumns,
      selectedRowByIds: [],
      selectedRows: [],
    };
  },
  computed: {
    ...mapGetters(["getIsEditor"]),
  },
  methods: {
    format,
    addParentClass(val) {
      this.tableParentClass = val;
    },
    getTableCellValue(row, col) {
      const value = row[col.slotKey];
      if (col.type === "date") {
        try {
          const date =
            value[value.length - 1] === "Z"
              ? value
              : value.indexOf("T") > -1
              ? `${value}Z`
              : getZonedTime(value);
          return date
            ? col?.format
              ? format(new Date(`${date}`), col.format)
              : format(new Date(`${date}`), "dd-MMM-yyyy")
            : "N/A";
        } catch (err) {
          return "-";
        }
      }
      if (value === true) {
        return "Yes";
      }
      if (value === false) {
        return "No";
      }
      return !value || typeof value === "undefined" || value === "null"
        ? "-"
        : value;
    },
    checkIfDisputeEditable() {
      if (this.caseDetails?.isDisputeEditable) {
        return false;
      }
      return true;
    },
    editVoiceDispute(rowData) {
      if (
        !this.activeVoiceDispute ||
        this.activeVoiceDispute.ohpDisputeVoiceId !== rowData.ohpDisputeVoiceId
      ) {
        this.activeVoiceDispute = rowData;
      } else {
        this.activeVoiceDispute = null;
      }
    },
    onMoreOptionClick(item) {
      event.stopPropagation();
      switch (item.id) {
        case "edit":
          if (this.getIsEditor) {
            this.openVoiceDispute = true;
          }
          break;
        case "edit_history":
          this.$emit("getVoiceDisputeEditHistory", this.activeVoiceDispute);
          this.openVoiceDisputeEditHistory = true;
          break;
        default:
          return;
      }
    },
    onModalClose() {
      this.openVoiceDispute = false;
      this.openVoiceDisputeEditHistory = false;
      this.activeVoiceDispute = null;
    },
    checkIsDisabled(row) {
      //     if (
      //     !row?.isHandedOverToCollections &&
      //     (this.caseDetails?.statusCode === "66" ||
      //       this.caseDetails?.statusCode === "67" ||
      //       this.caseDetails?.statusCode === "71" ||
      //       this.caseDetails?.statusCode === "72" ||
      //       this.caseDetails?.statusCode === "73" ||
      //       this.caseDetails?.statusCode === "74")
      //   ) {
      //     return false;
      //   } else return true;
      return row == this.data?.[0] ? row?.isHandedOverToCollections : true;
    },
    selectChangeEvent(selectedItems) {
      this.selectedRows = [...selectedItems];
      if (this.selectedRows?.length) {
        this.selectedRowByIds = this.selectedRows.map(
          (item) => item?.ohpDisputeVoiceId
        );
      } else {
        this.selectedRowByIds = [];
      }
    },
    handOverDataToCollections() {
      const selectedRow = this.data?.find(
        (item) => item.ohpDisputeVoiceId === this.selectedRowByIds?.[0]
      );
      this.$emit("updateVoiceDispute", {
        ohpDisputeVoiceId: selectedRow?.ohpDisputeVoiceId,
        ohpDisputeId: selectedRow?.ohpDisputeId,
        isHandedOverToCollections: "true",
      });
      this.selectedRowByIds = [];
      this.selectedRows = [];
    },
  },
};
</script>

<style lang="scss">
.dispute-with-voice {
  .table-parent-style {
    padding-bottom: 15px;
    border: 1px solid #e8eaec;
    .table-flex {
      overflow-x: scroll;
      width: auto !important;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #888;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .more-container {
    .more-dropdown {
      top: 8px;
      right: 48px;
    }
  }
}
</style>
<style lang="scss" scoped>
.dispute-with-voice {
  &__header {
    padding-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
  }
  .details-tab-area {
    &__action {
      margin-top: 16px;
      display: flex;
      justify-content: flex-end;
    }
  }
  .pointer {
    cursor: pointer;
  }
}
</style>
